interface BadgeProps {
  size?: number;
  className?: string;
}

export function Badge({ size = 80, className = '' }: BadgeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield background - white with black border */}
      <path
        d="M12 2L20 6V12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12V6L12 2Z"
        fill="white"
        stroke="#2a2e60"
        strokeWidth="1.5"
      />

      {/* Checkmark - green */}
      <path
        d="M8 12L11 15L16 9"
        stroke="#10B981"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
